import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { deleteAwbFromCart } from '../../store/actions/cartAction';
import { receiveServicesAndTariff } from '../../store/actions/addServiceAndTariffAction';
import { getGhaInfo } from '../../store/actions/ghaAction';

import Cart from './Cart';
import PrevNext from '../prevAndNext/PrevNext';
import ProcessBarContainer from '../processBar/ProcessBarContainer';
import AdditionalServicesModalContainer from './additionalServices/additionalServicesModal/AdditionalServicesModalContainer';

import CartModel from '../../models/Cart';
import CartItem from '../../models/CartItem';
import AddServicesTariff from '../../models/AddServicesTariff';
import { UserRoleType } from '../../models/User';

import cartStyles from './cart.module.css';
import commonStyles from '../common/common.module.css';
import PaymentHistory from './paymentHistory/PaymentHistory';

interface CartContainerState {
  addServicesModalOpen: boolean;
  selectedAwbCode: string;
  selectedAwbNumber: string;
  selectedAwbVer: number;
  paymentHistoryModal: boolean;
};

interface CartContainerProps {
  cart: CartModel;
  additionalService: AddServicesTariff;
  getServicesAndTariff: Function;
  deleteAwbFromCard: Function;
  userRole: UserRoleType;
  getGhaInfo: Function;
};
  
class CartContainer extends Component <CartContainerProps, CartContainerState> {

    state = {
      addServicesModalOpen: false,
      selectedAwbCode: '',
      selectedAwbNumber: '',
      paymentHistoryModal: false,
      selectedAwbVer: 0
    }

    componentDidMount() {

      this.loadServicesAndTariff(this.props);
    }

    componentDidUpdate(prevProps: CartContainerProps) {

      if (prevProps.cart.totalDue !== this.props.cart.totalDue &&
          prevProps.cart.remainDue !== this.props.cart.remainDue &&
          prevProps.cart.pickup_date !== this.props.cart.pickup_date) {

        this.loadServicesAndTariff(this.props);
      }
    }

    loadServicesAndTariff = (props: CartContainerProps): void => {

      const firstCartItem: CartItem | undefined = props.cart.items[0];

      if (firstCartItem) {
        props.getServicesAndTariff(firstCartItem.code, firstCartItem.number, firstCartItem.version);
        if (this.props.userRole === UserRoleType.GHA)
          this.props.getGhaInfo(firstCartItem.id_gha)
      }
    }

    openModalPaymentHistory = (cartItem: CartItem): void => {

      this.setState({
        paymentHistoryModal: true,
        selectedAwbCode: cartItem.code,
        selectedAwbNumber: cartItem.number,
        selectedAwbVer: cartItem.version
      });
    }

    openModalAdditionalServicesModalContainer = (cartItem: CartItem): void => {

      this.setState({
        addServicesModalOpen: true,
        selectedAwbCode: cartItem.code,
        selectedAwbNumber: cartItem.number,
        selectedAwbVer: cartItem.version
      });
    }

    handleClose = (): void => {
      this.setState({ addServicesModalOpen: false });
    }

    handleCloseHistory = (): void => {
      this.setState({ paymentHistoryModal: false });
    }

    render() {

        const cartItems: number = this.props.cart.items.length;
        let renderItem: JSX.Element = <div className={ cartStyles.emptyCart }>Your Cart is empty!</div>;
        const prevButtonHref: string = this.props.userRole === UserRoleType.FORWARDER ?  '/' : '/manual-entry-import';
        const nextButtonHref: string = this.props.userRole === UserRoleType.FORWARDER ? ((this.props as any).type === 'go' ? '/pay-go' : '/pay') : '/manual-entry-pay';

        if (cartItems > 0) {
          renderItem = <Cart
                          cart={ this.props.cart }
                          openAddServicesModal={ this.openModalAdditionalServicesModalContainer }
                          addServicesTariff={ this.props.additionalService }
                          deleteAwbFromCard={ this.props.deleteAwbFromCard }
                          userRole={ this.props.userRole }
                          openPaymentHistoryModal={ this.openModalPaymentHistory }
                        />;
        }
        return (
          <Fragment>
            <div className={ commonStyles.headerDummyDiv }></div>
            <ProcessBarContainer type='import' userRole={ this.props.userRole }/>
            { renderItem }
            <PrevNext prevButton={ { active: true, href: `${prevButtonHref}`, animate: true } } nextButton={ { active: true, href: `${nextButtonHref}`, animate: true } } />
            { this.state.addServicesModalOpen &&
              <AdditionalServicesModalContainer
                modalOpen={ this.state.addServicesModalOpen }
                handleClose={ this.handleClose }
                selectedAwbCode={ this.state.selectedAwbCode }
                selectedAwbNumber={ this.state.selectedAwbNumber }
                selectedAwbVer={ this.state.selectedAwbVer }
              />
            }
            { this.state.paymentHistoryModal &&
              <PaymentHistory
                modalOpen={ this.state.paymentHistoryModal }
                handleClose={ this.handleCloseHistory }
                code={ this.state.selectedAwbCode }
                number={ this.state.selectedAwbNumber }
              />
            }
          </Fragment>
        );
    }
}

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    additionalService: state.additionalService
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    deleteAwbFromCard: (awbCode: string, awbNumber: string) => dispatch(deleteAwbFromCart(awbCode, awbNumber)),
    getServicesAndTariff: (awbCode: string, awbNumber: string, version: number) => dispatch(receiveServicesAndTariff(awbCode, awbNumber, version)),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);